var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import WidgetDisplay from "@/components/widgets/widgetDisplay";
import { useSlotVisibility } from "@/hooks/layout";
import { useAppSelector } from "@/hooks/store";
import { Slot, SlotDirection, SlotSize } from "@/utils/types/layout";
import AddWidgetControl from "@/components/layout/edit/addWidget";
import { useFilteredWidgets } from "@/utils/themes/hooks";
import WidgetGrid from "./widgetGrid";
export default function MenuNorth() {
    var menuNorthVisible = useSlotVisibility().menuNorthVisible;
    var filteredWidgets = useFilteredWidgets(Slot.MENU_NORTH);
    var isEditingLayout = useAppSelector(function (state) { return state.layout.editingLayout; });
    var adminLayout = window.location.pathname.includes("InboundEmail") ||
        window.location.pathname.includes("OutboundEmailAccounts") ||
        window.location.pathname.includes("OAuthTokens") ||
        window.location.pathname.includes("OAuthKeys") ||
        window.location.pathname.includes("EmailMan") ||
        window.location.pathname.includes("ModuleBuilder") ||
        window.location.pathname.includes("modules/Administration") ||
        window.location.pathname.includes("SecurityGroups") ||
        window.location.search.includes("page=admin");
    var widgetAdminMenu = {
        id: "widgetMenuHorizontal",
        actionUrl: "index",
        module: "Administration",
        type: "widget/admin/menu/horizontal",
        slot: Slot.MENU_NORTH,
        payload: { currentTotalColspan: 1 },
        meta: {
            order: 0,
            visible: true,
            pinned: true,
            direction: SlotDirection.HORIZONTAL,
            size: SlotSize.NORMAL,
        },
    };
    var widgets = adminLayout
        ? __spreadArray(__spreadArray([], filteredWidgets, true), [widgetAdminMenu], false) : filteredWidgets;
    var areaVisible = (menuNorthVisible && widgets.length > 0) || isEditingLayout;
    if (areaVisible) {
        if (widgets.length === 0 && !isEditingLayout) {
            return _jsx(_Fragment, {});
        }
        return (_jsxs("nav", __assign({ className: " ".concat(widgets && "rounded  border-[var(--colors-widget-border)]", " h-auto flex justify-between bg-[var(--colors-menu-north-bg)] flex-none navbar direction-horizontal z-[31] overflow-hidden  mt-[var(--margin-mt-menu-north)] mr-[var(--margin-mr-menu-north)]\n      mb-[var(--margin-mb-menu-north)] ml-[var(--margin-ml-menu-north)] w-full") }, { children: [_jsx(_Fragment, { children: adminLayout ? (_jsx("div", __assign({ className: "w-full h-full overflow-auto widgets-container small" }, { children: _jsx("div", __assign({ className: "widgets ".concat(adminLayout ? "" : "flex flex-row") }, { children: widgets.map(function (widget) { return (_jsx(WidgetDisplay, { widget: widget }, widget.id)); }) })) }))) : (_jsx("div", __assign({ className: "relative w-full h-full overflow-hidden widgets-container scroll-elements" }, { children: _jsx(WidgetGrid, { direction: SlotDirection.HORIZONTAL, filteredWidgets: widgets, isEditingLayout: isEditingLayout }) }))) }), isEditingLayout && _jsx(AddWidgetControl, { to: Slot.MENU_NORTH })] })));
    }
    return _jsx(_Fragment, {});
}
